<template>
  <div
    class="SpMessageNotify"
    :style="styleMerge"
  >
    <div class="current-active" />
    <div class="scrolltopBox">
      <div class="icon">
        <i class="el-icon-microphone" />
      </div>
      <div class="scrolltop s1">
        <VueLoopScroll
          v-if="viewData.options.length"
          ref="VueLoopScroll"
          :auto-play="viewData.autoPlay"
          direction="left"
          :speed="20"
          :index="VueLoopScrollKey"
          :mouse-stop="false"
        >
          <li
            v-for="(item, index) in viewData.options"
            :key="index"
          >
            {{ item }}
          </li>
        </VueLoopScroll>
        <div v-else>
          请添加滚动播放文本
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueLoopScroll, { getIndex } from './comps/VueLoopScroll.vue'
import formMixin from '@/view/weappTmp/core/lib/package/comps-node-mixin.js'
export default {
  name: 'SpMessageNotify',
  components: {
    VueLoopScroll
  },
  mixins: [formMixin],
  props: {},
  data () {
    const VueLoopScrollKey = getIndex()
    return {
      VueLoopScrollKey,
      inputVal: null,
      viewData: {
        margin: [0, 0, 0, 0],
        options: [],
        autoPlay: false
      }
    }
  },
  watch: {
    // viewData:{
    //   deep: true,
    //   handle:(n,o)=>{
    //     if(JSON.stringify(n.options)!= JSON.stringify(o.options) ){
    //       console.log('VueLoopScroll',this.$ref['VueLoopScroll'])
    //     }
    //   }
    // }
  },
  mounted () {
    // console.log('spinput-viewData',this.viewData)
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.SpMessageNotify {
  background: #fff;
}
.flex_box {
  // 纵向
  &_Vertical {
  }
  // 横向
  &_Horizontal {
    display: flex;
  }
}
.scrolltop {
  width: 90%;
  &.s1 {
    li {
      // line-height: 50px;
    }
  }
  &.s2 {
    .vue-loop-scroll-box {
      height: 200px;
    }
  }
}
.scrolltopBox {
  display: flex;
  line-height: 30px;
  height: 30px;
  .icon {
    font-size: 22px;
  }
}
</style>
